export function safeParseJson(jsonString) {
  try {
    return JSON.parse(jsonString);
  } catch (e) {
    console.error("Failed to parse JSON", e);
    return null;
  }
}
